import { Pipe, PipeTransform } from '@angular/core';

export function transformBooleanYesNo(value?: boolean | null): string {
  if (value == null) {
    return '';
  }
  return value ? 'Yes' : 'No';
}

@Pipe({
  name: 'booleanYesNo',
  standalone: false
})
export class BooleanYesNoPipe implements PipeTransform {
  transform(value?: boolean | null): string {
    return transformBooleanYesNo(value);
  }
}
